import type { Lang } from '@/types';

const MONTHS: Record<Lang, string[]> = {
  uz: ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentabr', 'oktabr', 'noyabr', 'dekabr'],
  ru: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};

/** Toshkent (UTC+5, yozgi vaqt yo'q) */
const TASHKENT_OFFSET_MS = 5 * 60 * 60 * 1000;

/**
 * "16 oktabr 2026" — Toshkent vaqti bo'yicha, brauzer vaqt zonasiga bog'liq emas:
 * prerender (UTC konteyner) va client hydration bir xil matn beradi (ikkalasi ham uz da).
 */
export function formatPostDate(iso?: string | null, lang: Lang = 'uz'): string {
  if (!iso) return '';
  const d = new Date(new Date(iso).getTime() + TASHKENT_OFFSET_MS);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getUTCDate()} ${MONTHS[lang][d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
